var layout_default = {
  "layout": "-GMys",
  "cell": "PHawe"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
